import { useParams } from 'react-router-dom';

import { snackbar } from '@occc-app/design-system';
import { FullScreenProgress } from '@occc/ui-design-system';
import { RetailerNetworkUpdate, RetailerNetworkUpdateMutationOptions } from '@occc/graphql';

import { RetailerNetworkDetailsPage } from './retailer-network-details-page.component';

import { useRetailerNetworkUpdateMutation } from '../../data-access/mutations';
import { useGetRetailerNetworkQuery } from '../../data-access/queries';
import { useBreadcrumbLinks } from '../hooks/use-breadcrumb-links.hook';
import { RetailerNetworkErrorMessage } from '../components/retailer-network-error-message.component';
import { RetailerNetworkNoData } from '../components/retailer-network-no-data.component';

const BREADCRUMB_LINKS = [{ label: 'Retailer Network' }];

export const RetailerNetworkDetailsPageContainer = () => {
  const { networkId = '' } = useParams<{ networkId: string }>();
  const { data, loading, error } = useGetRetailerNetworkQuery(
    {
      variables: { uuid: networkId },
    },
    !networkId,
  );

  useBreadcrumbLinks(BREADCRUMB_LINKS);

  const [retailerNetworkUpdateMutation] = useRetailerNetworkUpdateMutation({
    onCompleted: () => {
      snackbar.success('Retailer Network has been successfully updated');
    },
  });

  const retailerNetworkUpdate = async (
    input: Omit<RetailerNetworkUpdate, 'uuid'>,
    refetchQueries: RetailerNetworkUpdateMutationOptions['refetchQueries'],
  ) => {
    if (data?.retailerNetwork) {
      await retailerNetworkUpdateMutation({
        refetchQueries,
        variables: {
          input: {
            uuid: data.retailerNetwork.uuid,
            ...input,
          },
        },
      });
    }
  };

  if (loading && !data) {
    return <FullScreenProgress />;
  }

  if (error) {
    return <RetailerNetworkErrorMessage />;
  }

  if (!data) {
    return <RetailerNetworkNoData />;
  }

  return (
    <RetailerNetworkDetailsPage
      retailerNetwork={data.retailerNetwork}
      retailerNetworkUpdate={retailerNetworkUpdate}
    />
  );
};
